import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';

@Component({

  selector: 'app-transit-report-stop',

  templateUrl: './transit-report-stop.component.html',

  styleUrls: ['./transit-report-stop.component.css']

})

export class TransitReportStopComponent implements OnInit {

  mdl_Search: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    iTransit_Trip: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _other: OtherService,

  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.mdl_Search.patchValue({

        iTransit_Trip: params['id']

      })

      this.getRouteStops()

    });

  }

  getRouteStops = async () => {

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TransitRoute_Stops_List`, this._other.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    // console.log(res)
  }

}
